/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmTriggerV1TriggerState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_TRIGGER_V1_TRIGGER_STATE_ENTITY_NAME = 'ixm.trigger.v1.Trigger';
export const ixmTriggerV1TriggerStateEntity = new schema.Entity<IxmTriggerV1TriggerState>(IXM_TRIGGER_V1_TRIGGER_STATE_ENTITY_NAME, {}, { idAttribute: 'triggerId' });

